import api from './api';
import { Assessment, AssessmentStatusResponse, AssessmentResults, SalesStrategy, StartAssessmentInput } from '../types';

export async function startAssessment(input: StartAssessmentInput): Promise<Assessment> {
  const response = await api.post<Assessment>('/assessments', input);
  return response.data;
}

export async function getAssessment(id: string): Promise<Assessment> {
  const response = await api.get<Assessment>(`/assessments/${id}`);
  return response.data;
}

export async function getAssessmentsByClient(clientId: string): Promise<Assessment[]> {
  const response = await api.get<Assessment[]>(`/assessments?clientId=${clientId}`);
  return response.data;
}

export async function getAssessmentStatus(id: string): Promise<AssessmentStatusResponse> {
  const response = await api.get<AssessmentStatusResponse>(`/assessments/${id}/status`);
  return response.data;
}

export async function getAssessmentResults(id: string): Promise<{ results: AssessmentResults; strategies?: SalesStrategy[]; roleArn?: string }> {
  const response = await api.get<{ results: AssessmentResults; strategies?: SalesStrategy[]; roleArn?: string }>(`/assessments/${id}/results`);
  return response.data;
}
